module.exports = __webpack_public_path__ + "media/red-alert-siren.e2317a37.mp3";